//import { useNavigate } from "react-router-dom";

import {
  formatError,
  // login,
  loginSA,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
  verify2FALogin,
  sendLogin2FAEmailCode,
} from "../../services/AuthService";

import swal from "sweetalert";
import {
  beginFranchisePortalSession,
  endTabScopedAuthSession,
  isTabScopedAuthSession,
} from "../../utils/authToken";
export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";
export const LOGIN_2FA_REQUIRED_ACTION = "[login action] 2fa required";

function completeRestaurantLogin(dispatch, response) {
  const user = response?.user;

  if (!user) {
    swal("Error", "Unexpected error, please try again.", "error");
    return false;
  }

  if (user.role === "resFranchise") {
    if (!user.activate) {
      swal("Error", "Your account has been deactivated", "error");
      return false;
    }

    beginFranchisePortalSession(response.tokenLogin, {
      email: user.email,
      franchiseFK: user.franchiseFK || "",
    });
    dispatch(
      loginConfirmedAction({
        ...response,
        idToken: response.tokenLogin,
      })
    );
    window.location.href = "/franchise-restaurants";
    return true;
  }

  if (user.role !== "responsable") {
    swal(
      "Error",
      "Only Restaurant Admin can have authorization to login to this space",
      "error"
    );
    return false;
  }

  if (!user.activate) {
    swal("Error", "Your account has been deactivated", "error");
    return false;
  }

  endTabScopedAuthSession();
  localStorage.setItem("tokenLogin", response.tokenLogin);
  localStorage.setItem("email", user.email);
  localStorage.setItem("userRole", user.role);
  localStorage.setItem("isOwner", JSON.stringify(Boolean(user.isOwner)));
  localStorage.setItem(
    "userPermissions",
    JSON.stringify(Array.isArray(user.permissions) ? user.permissions : [])
  );
  localStorage.removeItem("franchiseFK");
  dispatch(loginConfirmedAction(response));
  window.location.href = "/dashboard";
  return true;
}

export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        if (response?.data?.user?.role != "superAdmin") {
          swal(
            "Error",
            "Only Super Admin can have authorization to login to this space",
            "error"
          );
        } else {
          saveTokenInLocalStorage(response.data);
          runLogoutTimer(
            dispatch,
            response.data.expiresIn * 1000
            //history,
          );
          dispatch(confirmedSignupAction(response.data));
          navigate("https://admin.clictoeat.com/dashboard");
        }

        //history.push('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  if (isTabScopedAuthSession()) {
    endTabScopedAuthSession();
  } else {
    localStorage.removeItem("tokenLogin");
    localStorage.removeItem("userRole");
    localStorage.removeItem("franchiseFK");
    localStorage.removeItem("email");
    localStorage.removeItem("restaurantId");
    localStorage.removeItem("restaurantCurrency");
    localStorage.removeItem("restaurantSecondaryCurrency");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("isOwner");
    localStorage.removeItem("userPermissions");
  }
  navigate("/login", { replace: true });

  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, navigate) {
  return (dispatch) => {
    return loginSA(email, password)
      .then((response) => {
        if (response?.requires2FA) {
          dispatch({
            type: LOGIN_2FA_REQUIRED_ACTION,
            payload: { tempToken: response.tempToken },
          });
          return {
            requires2FA: true,
            tempToken: response.tempToken,
          };
        }

        completeRestaurantLogin(dispatch, response);
        return { requires2FA: false };
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          "Failed to login. Please try again.";
        swal("Error", errorMessage, "error");
        dispatch(loginFailedAction(errorMessage));
        return { requires2FA: false, error: true };
      });
  };
}

export function verify2FAAction(tempToken, code, method = "authenticator") {
  return (dispatch) => {
    if (!code || String(code).trim().length < 6) {
      const msg =
        method === "email"
          ? "Enter the 6-digit code sent to your email."
          : "Enter the 6-digit code from Google Authenticator.";
      dispatch(loginFailedAction(msg));
      swal("Error", msg, "error");
      return Promise.resolve(false);
    }

    return verify2FALogin(tempToken, code, method)
      .then((response) => completeRestaurantLogin(dispatch, response))
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          (method === "email"
            ? "Invalid email verification code. Please try again."
            : "Invalid authenticator code. Please try again.");
        swal("Error", errorMessage, "error");
        dispatch(loginFailedAction(errorMessage));
        return false;
      });
  };
}

export function sendLogin2FAEmailAction(tempToken) {
  return (dispatch) => {
    if (!tempToken) {
      const msg = "2FA session expired. Please login again.";
      dispatch(loginFailedAction(msg));
      swal("Error", msg, "error");
      return Promise.resolve(null);
    }

    return sendLogin2FAEmailCode(tempToken)
      .then((response) => {
        swal(
          "Email sent",
          response?.message || "Verification code sent to your email.",
          "success"
        );
        return response;
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          "Failed to send verification code. Please try again.";
        swal("Error", errorMessage, "error");
        dispatch(loginFailedAction(errorMessage));
        return null;
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
